import { formatMoney } from '../../../shared/lib/money'

export interface Outlet {
  id: string
  subMerchantId: string
  name: string
  category: 'F&B' | 'Retail' | 'Luxury' | 'Services' | 'Entertainment'
  mall: string
  floorZone: string
  floorAreaSqft: number
  channels: ('POS' | 'E-com' | 'APM')[]
  status: 'Active' | 'Onboarding' | 'Suspended' | 'Closed'
  periodGmv: number
  txnCount: number
  avgTicket: number
  refundRate: number
  chargebackRate: number
  growth: number
  settlementAccount: string
}

export const malls = ['Saujana Sentral KL', 'Saujana Damansara']

export const outletsData: Outlet[] = [
  {
    id: 'out_1',
    subMerchantId: 'SM-1001',
    name: 'Kopi Tiam Saujana',
    category: 'F&B',
    mall: 'Saujana Sentral KL',
    floorZone: 'LG-Food',
    floorAreaSqft: 1200,
    channels: ['POS', 'APM'],
    status: 'Active',
    periodGmv: 145000,
    txnCount: 4833,
    avgTicket: 30,
    refundRate: 0.5,
    chargebackRate: 0.01,
    growth: 5.2,
    settlementAccount: 'MBB-1122334455',
  },
  {
    id: 'out_2',
    subMerchantId: 'SM-1002',
    name: 'Nyonya Table',
    category: 'F&B',
    mall: 'Saujana Sentral KL',
    floorZone: 'LG-Food',
    floorAreaSqft: 1500,
    channels: ['POS', 'E-com', 'APM'],
    status: 'Active',
    periodGmv: 210000,
    txnCount: 3500,
    avgTicket: 60,
    refundRate: 1.2,
    chargebackRate: 0.05,
    growth: 8.4,
    settlementAccount: 'MBB-1122334456',
  },
  {
    id: 'out_3',
    subMerchantId: 'SM-1003',
    name: 'The Brew Bar',
    category: 'F&B',
    mall: 'Saujana Damansara',
    floorZone: 'G-Alfresco',
    floorAreaSqft: 800,
    channels: ['POS', 'APM'],
    status: 'Active',
    periodGmv: 95000,
    txnCount: 4750,
    avgTicket: 20,
    refundRate: 0.2,
    chargebackRate: 0.0,
    growth: 12.1,
    settlementAccount: 'CIMB-9988776655',
  },
  {
    id: 'out_4',
    subMerchantId: 'SM-1004',
    name: 'Urban Thread',
    category: 'Retail',
    mall: 'Saujana Sentral KL',
    floorZone: 'L1-Fashion',
    floorAreaSqft: 2500,
    channels: ['POS', 'E-com', 'APM'],
    status: 'Active',
    periodGmv: 350000,
    txnCount: 1400,
    avgTicket: 250,
    refundRate: 4.5,
    chargebackRate: 0.1,
    growth: -2.3,
    settlementAccount: 'MBB-1122334457',
  },
  {
    id: 'out_5',
    subMerchantId: 'SM-1005',
    name: 'TechHaus',
    category: 'Retail',
    mall: 'Saujana Damansara',
    floorZone: 'L2-Tech',
    floorAreaSqft: 1800,
    channels: ['POS', 'E-com', 'APM'],
    status: 'Active',
    periodGmv: 850000,
    txnCount: 850,
    avgTicket: 1000,
    refundRate: 2.1,
    chargebackRate: 0.5,
    growth: 15.6,
    settlementAccount: 'HLB-5544332211',
  },
  {
    id: 'out_6',
    subMerchantId: 'SM-1006',
    name: 'BookNook',
    category: 'Retail',
    mall: 'Saujana Sentral KL',
    floorZone: 'L3-Leisure',
    floorAreaSqft: 3000,
    channels: ['POS', 'APM'],
    status: 'Active',
    periodGmv: 120000,
    txnCount: 2400,
    avgTicket: 50,
    refundRate: 0.8,
    chargebackRate: 0.0,
    growth: 1.5,
    settlementAccount: 'MBB-1122334458',
  },
  {
    id: 'out_7',
    subMerchantId: 'SM-1007',
    name: 'Maison Lumière',
    category: 'Luxury',
    mall: 'Saujana Sentral KL',
    floorZone: 'G-Luxury',
    floorAreaSqft: 4500,
    channels: ['POS', 'APM'],
    status: 'Active',
    periodGmv: 2500000,
    txnCount: 125,
    avgTicket: 20000,
    refundRate: 1.0,
    chargebackRate: 0.0,
    growth: 4.2,
    settlementAccount: 'SCB-123456789',
  },
  {
    id: 'out_8',
    subMerchantId: 'SM-1008',
    name: 'Aurelia Timepieces',
    category: 'Luxury',
    mall: 'Saujana Sentral KL',
    floorZone: 'G-Luxury',
    floorAreaSqft: 2000,
    channels: ['POS', 'APM'],
    status: 'Active',
    periodGmv: 1800000,
    txnCount: 60,
    avgTicket: 30000,
    refundRate: 0.0,
    chargebackRate: 0.0,
    growth: 18.5,
    settlementAccount: 'MBB-1122334459',
  },
  {
    id: 'out_9',
    subMerchantId: 'SM-1009',
    name: 'GlowSpa',
    category: 'Services',
    mall: 'Saujana Damansara',
    floorZone: 'L3-Wellness',
    floorAreaSqft: 2200,
    channels: ['POS', 'E-com', 'APM'],
    status: 'Active',
    periodGmv: 180000,
    txnCount: 900,
    avgTicket: 200,
    refundRate: 3.2,
    chargebackRate: 0.2,
    growth: 6.7,
    settlementAccount: 'CIMB-9988776656',
  },
  {
    id: 'out_10',
    subMerchantId: 'SM-1010',
    name: 'QuickFix Mobile',
    category: 'Services',
    mall: 'Saujana Sentral KL',
    floorZone: 'L2-Tech',
    floorAreaSqft: 400,
    channels: ['POS', 'APM'],
    status: 'Active',
    periodGmv: 65000,
    txnCount: 650,
    avgTicket: 100,
    refundRate: 1.5,
    chargebackRate: 0.5,
    growth: -5.0,
    settlementAccount: 'MBB-1122334460',
  },
  {
    id: 'out_11',
    subMerchantId: 'SM-1011',
    name: 'PlayZone Arcade',
    category: 'Entertainment',
    mall: 'Saujana Damansara',
    floorZone: 'L4-Entertainment',
    floorAreaSqft: 8000,
    channels: ['POS', 'APM'],
    status: 'Active',
    periodGmv: 420000,
    txnCount: 8400,
    avgTicket: 50,
    refundRate: 0.1,
    chargebackRate: 0.0,
    growth: 22.4,
    settlementAccount: 'RHB-1122334455',
  },
]

export const getPortfolioStats = () => {
  const totalGmv = outletsData.reduce((acc, o) => acc + o.periodGmv, 0)
  const totalTxn = outletsData.reduce((acc, o) => acc + o.txnCount, 0)
  const activeOutlets = outletsData.filter((o) => o.status === 'Active').length
  const avgTicket = totalGmv / totalTxn
  const netSettled = totalGmv * 0.98 // rough mock
  const mdrFees = totalGmv * 0.015
  const refunds = totalGmv * 0.005

  return {
    totalGmv,
    totalTxn,
    avgTicket,
    activeOutlets,
    netSettled,
    mdrFees,
    refunds,
  }
}
